import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBookmark';
/** Renders an SVG icon. */
const SvgBookmark = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="m22 25.057-4.838-3.455a2 2 0 0 0-2.324 0L10 25.057V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM24 9a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3v17.028c0 1.182 1.294 1.885 2.277 1.284l.095-.063L16 23.229l5.628 4.02.095.063c.983.601 2.277-.102 2.277-1.284z"
      />
    </svg>
  );
};
SvgBookmark.displayName = displayName;
export default SvgBookmark;
